"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Veiculo = void 0;
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
const typeorm_1 = require("typeorm");
let Veiculo = class Veiculo extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdVeiculo = void (0);
        this.cdProprietario = void (0);
        this.cdModelo = void (0);
        this.cdTipoVeiculo = void (0);
        this.cdReboque = void (0);
        this.nrPlaca = void (0);
        this.nrPlaca2 = void (0);
        this.nrAnoFabricacao = void (0);
        this.nrAnoModelo = void (0);
        this.nmCor = void (0);
        this.nrPortas = void (0);
        this.nrChassi = void (0);
        this.nrRenavam = void (0);
        this.nrHodometroInicial = void (0);
        this.tpCombustivel = void (0);
        this.nrCapacidade = void (0);
        this.nrPotencia = void (0);
        this.nrCilindrada = void (0);
        this.nrTabelaReferencia = void (0);
        this.txtObservacao = void (0);
        this.qtCapacidadeTanque = void (0);
        this.qtConsumoUrbano = void (0);
        this.qtRodoviario = void (0);
        this.tpEixoDianteiro = void (0);
        this.tpEixoTraseiro = void (0);
        this.qtEixosDianteiros = void (0);
        this.qtEixosTraseiros = void (0);
        this.stVeiculo = void (0);
        this.qtHodometroAtual = void (0);
        this.cdCor = void (0);
        this.cdTipo = void (0);
        this.cdCategoria = void (0);
        this.cdMarca = void (0);
        this.cdEspecie = void (0);
        this.cdEndereco = void (0);
        this.cdCidade = void (0);
        this.cdFrota = void (0);
        this.tpAdaptacao = void (0);
        this.tpUtilizacao = void (0);
        this.cdMarcaCarroceria = void (0);
        this.nrAnoChassi = void (0);
        this.nrAnoCarroceria = void (0);
        this.nmPrefixo = void (0);
        this.nrAnoLicenciamento = void (0);
        this.qtEntreEixos = void (0);
        this.qtComprimentoInterno = void (0);
        this.qtLarguraInterno = void (0);
        this.qtLarguraCorredor = void (0);
        this.qtAreaCorredor = void (0);
        this.qtMaxEmPe = void (0);
        this.nrLicenciamento = void (0);
        this.cdPlanoVistoria = void (0);
        this.lgComodato = void (0);
        this.lgVeiculoNovo = void (0);
    }
};
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_veiculo", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdVeiculo", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_proprietario", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdProprietario", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_modelo", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdModelo", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_tipo_veiculo", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdTipoVeiculo", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_reboque", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdReboque", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_placa", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrPlaca", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_placa2", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrPlaca2", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_ano_fabricacao", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrAnoFabricacao", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_ano_modelo", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrAnoModelo", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_cor", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nmCor", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "nr_portas", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "nrPortas", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_chassi", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrChassi", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_renavam", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrRenavam", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "nr_hodometro_inicial", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "nrHodometroInicial", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_combustivel", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "tpCombustivel", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_capacidade", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrCapacidade", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "nr_potencia", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "nrPotencia", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "nr_cilindrada", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "nrCilindrada", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_tabela_referencia", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrTabelaReferencia", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "txt_observacao", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "txtObservacao", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "qt_capacidade_tanque", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtCapacidadeTanque", void 0);
__decorate([
    typeorm_1.Column("double precision", { name: "qt_consumo_urbano", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtConsumoUrbano", void 0);
__decorate([
    typeorm_1.Column("double precision", { name: "qt_rodoviario", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtRodoviario", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_eixo_dianteiro", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "tpEixoDianteiro", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_eixo_traseiro", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "tpEixoTraseiro", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "qt_eixos_dianteiros", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtEixosDianteiros", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "qt_eixos_traseiros", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtEixosTraseiros", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "st_veiculo", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "stVeiculo", void 0);
__decorate([
    typeorm_1.Column("double precision", { name: "qt_hodometro_atual", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtHodometroAtual", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_cor", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdCor", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_tipo", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdTipo", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_categoria", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdCategoria", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_marca", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdMarca", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_especie", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdEspecie", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_endereco", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdEndereco", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_cidade", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdCidade", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_frota", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdFrota", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_adaptacao", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "tpAdaptacao", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_utilizacao", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "tpUtilizacao", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_marca_carroceria", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdMarcaCarroceria", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_ano_chassi", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrAnoChassi", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_ano_carroceria", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrAnoCarroceria", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_prefixo", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nmPrefixo", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_ano_licenciamento", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrAnoLicenciamento", void 0);
__decorate([
    typeorm_1.Column("double precision", { name: "qt_entre_eixos", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtEntreEixos", void 0);
__decorate([
    typeorm_1.Column("double precision", { name: "qt_comprimento_interno", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtComprimentoInterno", void 0);
__decorate([
    typeorm_1.Column("double precision", { name: "qt_largura_interno", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtLarguraInterno", void 0);
__decorate([
    typeorm_1.Column("double precision", { name: "qt_largura_corredor", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtLarguraCorredor", void 0);
__decorate([
    typeorm_1.Column("double precision", { name: "qt_area_corredor", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtAreaCorredor", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "qt_area_corredor", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "qtMaxEmPe", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_licenciamento", nullable: true }),
    __metadata("design:type", String)
], Veiculo.prototype, "nrLicenciamento", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_plano_vistoria", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "cdPlanoVistoria", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_comodato", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "lgComodato", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_veiculo_novo", nullable: true }),
    __metadata("design:type", Number)
], Veiculo.prototype, "lgVeiculoNovo", void 0);
Veiculo = __decorate([
    typeorm_1.Entity('fta_veiculo')
], Veiculo);
exports.Veiculo = Veiculo;
